<template>
    <div id="editor_outline">
        <div class="editor_novel">作品大纲</div>
        <div class="editor_outline">
            <div class="editor_outline1" v-for="(item, i) in noveloutline" :key="i">
                <div class="editor_outline2" @click="toggleOutline(i)">
                    <div class="editor_outline3">{{ item.name }}</div>
                    <img :src="require('../assets/image/icon_editor6.png')" :class="{ rotated: item.isOpen }" alt="">
                </div>
                <transition name="slide" @after-enter="onAfterEnter(i)">
                    <div class="editor_outline4" v-if="item.isOpen">{{ item.content }}</div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/utils/eventBus';
import api from '@/api/api';
export default {
    data() {
        return {
            noveloutline: [],
        };
    },
    mounted() {
        EventBus.$on('toPage', (i) => {
            this.getChapterList(i)
        });
        
    },
    beforeDestroy() {
        EventBus.$off('toPage');
    },
    methods: {
        getChapterList(i) {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'));
            api.getChapterList(editItem.id).then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.noveloutline = res.data.map(item => ({ ...item, isOpen: false }))
                    if (i >= 0 && i < this.noveloutline.length) {
                        this.noveloutline[i].isOpen = true;
                    }
                    // console.log(this.noveloutline)
                }
            })
        },
        toggleOutline(index) {
            this.noveloutline[index].isOpen = !this.noveloutline[index].isOpen;
        },
        onAfterEnter(index) {
            const targetElement = document.querySelector(`.editor_outline1:nth-child(${index + 1}) .editor_outline2`);
            if (targetElement) {
                // 使用 scrollIntoView 方法滚动到目标元素
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }
};
</script>

<style scoped>
#editor_outline {
    height: 100%;
}

.editor_outline {
    width: 100%;
    height: calc(100% - 68px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.editor_outline1 {
    margin: 20px 15px;
}

.editor_outline2 {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-weight: bold;
    font-size: 17px;
    color: #0A0A0A;
    cursor: pointer;
}

.editor_outline2 img {
    width: 13px;
    height: 13px;
    margin-left: 8px;
    transition: transform 0.3s linear;
}

.editor_outline2 img.rotated {
    transform: rotate(180deg);
}

.editor_outline3 {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.editor_outline4 {
    font-size: 15px;
    color: #444444;
    overflow: hidden;
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s linear;
}

.slide-enter,
.slide-leave-to {
    height: 0;
    opacity: 0;
}
</style>    